import * as React from 'react';

const RV = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={22} height={22} viewBox="0 0 22 22" {...props}>
        <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.3}>
            <path
                strokeWidth={1.191671}
                d="M15.813 17.875a1.375 1.375 0 1 0 2.75 0 1.375 1.375 0 1 0-2.75 0M3.438 17.875a1.375 1.375 0 1 0 2.75 0 1.375 1.375 0 1 0-2.75 0"
            />
            <path
                strokeWidth={1.191671}
                d="M18.563 17.875h1.375a1.375 1.375 0 0 0 1.375-1.375v-2.75a2.14 2.14 0 0 0-.4-1.247L17.875 8.25h-4.812v9.625M21.313 13.75h-8.25"
            />
            <path
                strokeWidth={1.191671}
                d="M13.063 17.875V11H.688v5.5a1.375 1.375 0 0 0 1.375 1.375h1.374M15.813 17.875H6.188M21.313 5.5a2.75 2.75 0 0 1-2.75 2.75h-5.5V11H.688V5.5a2.75 2.75 0 0 1 2.75-2.75h15.125a2.75 2.75 0 0 1 2.75 2.75M18.563 5.5h-1.375M11.688 5.5h-8.25"
            />
        </g>
    </svg>
);
export default RV;
